import styled from 'styled-components';

const LedLightingWrapper = styled.div``;

export { LedLightingWrapper };
